import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const component = ( { views } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.videoEmptyView }>
			<div className = { classes.header }>
				<Typography
					color = { "white" }
					title = "This live stream has ended."
				/>
			</div>

			{/* <div className = { classes.subHeader }>
				<EyeIcon width = "15px" />

				<Typography
					className = { classes.subHeaderChild }
					title = { `${ views } watched` }
				/>

			</div>*/}
		</div>
	);
};

export default component;
